import { render, staticRenderFns } from "./listDossier.vue?vue&type=template&id=05f651d4&"
import script from "./listDossier.vue?vue&type=script&lang=js&"
export * from "./listDossier.vue?vue&type=script&lang=js&"
import style0 from "./listDossier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports